import { useSteps } from "./useSteps";
import React from "react";

interface StepWrapperProps {
	children: React.ReactNode;
	formStep: number;
	onSubmit: React.SubmitEventHandler<HTMLFormElement>;
	subtitle?: string;
	title: string;
}

export default function StepWrapper({
	children,
	formStep,
	onSubmit,
	title,
	subtitle,
}: StepWrapperProps) {
	const { step } = useSteps();

	if (step !== formStep) {
		return null;
	}

	return (
		<form id="subscription-form" aria-label={title} onSubmit={onSubmit}>
			<div className="step-wrapper">
				<fieldset className="form-step">
					<legend className="title">{title}</legend>
					{subtitle && <p className="subtitle">{subtitle}</p>}
					{children}
				</fieldset>
			</div>
		</form>
	);
}
